import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1391183021/src/actions-runner/_work/eon-service/eon-service/node_modules/@mui/material/esm/Box/Box.js");
